import countryRepository from "./countryRepository";
import guestRepository from "./guestRepository";
import reservationRepository from "./reservationRepository";
import roomRepository from "./roomRepository";
import roomCategoryRepository from "./roomCategoryRepository";
import sourceRepository from "./sourceRepository";
import technicianRepository from "./technicianRepository";
import staffPositionRepository from "./staffPositionRepository";
import maintenanceIssueRepository from "./maintenanceIssueRepository";
import roomStatusRepository from "./roomStatusRepository";
import vendorRepository from "./vendorRepository";
import paymentMethodRepository from "./paymentMethodRepository";
import extraChargeRepository from "./extraChargeRepository";
import extraChargeCategoryRepository from "./extraChargeCategoryRepository";
import checkinRepository from "./checkinRepository";
import inhouseRepository from "./inhouseRepository";
import inventoryOverallRepository from "./inventoryOverallRepository";
import inventoryWarehouseRepository from "./inventoryWarehouseRepository";
import inventoryDefectRepository from "./inventoryDefectRepository";
import inventoryRoomRepository from "./inventoryRoomRepository";
import inventoryRepository from "./inventoryRepository";
import maintenanceRepository from "./maintenanceRepository";
import roomManagementRepository from "./roomManagementRepository";
import employeeRepository from "./employeeRepository";
import adminRepository from "./adminRepository";
import scheduleRepository from "./scheduleRepository";
import cleaningRepository from "./cleaningRepository";
import { housekeepingCommissionRepository } from "./housekeepingCommissionRepository";
import authRepository from "./authRepository";
import reservationMergeRepository from "./reservationMergeRepository";
import reportRepository from "./reportRepository";
import backupRepository from "./backupRepository";

const repositories = {
  countries: countryRepository,
  guests: guestRepository,
  reservations: reservationRepository,
  rooms: roomRepository,
  roomCategory: roomCategoryRepository,
  source: sourceRepository,
  technician: technicianRepository,
  staffPosition: staffPositionRepository,
  maintenanceIssue: maintenanceIssueRepository,
  roomStatus: roomStatusRepository,
  vendor: vendorRepository,
  paymentMethod: paymentMethodRepository,
  extraCharges: extraChargeRepository,
  extraChargeCategory: extraChargeCategoryRepository,
  checkin: checkinRepository,
  inhouse: inhouseRepository,
  inventoryOverall: inventoryOverallRepository,
  inventoryWarehouse: inventoryWarehouseRepository,
  inventoryDefect: inventoryDefectRepository,
  inventoryRoom: inventoryRoomRepository,
  inventory: inventoryRepository,
  maintenance: maintenanceRepository,
  roomManagement: roomManagementRepository,
  employee: employeeRepository,
  admin: adminRepository,
  schedule: scheduleRepository,
  cleaning: cleaningRepository,
  housekeepingCommission: housekeepingCommissionRepository,
  auth: authRepository,
  reservationMerge: reservationMergeRepository,
  report: reportRepository,
  backup: backupRepository,
};
export default {
  install(app) {
    app.provide("repositories", repositories);

    app.config.globalProperties.$repositories = repositories;
  },
};
